import React, { Component } from "react";
import ReactDOM from "react-dom";

import { ENDPOINTS } from "../../constants/endpoints";

class EventPayment extends Component {
  constructor(props) {
    super(props);
    this.state = { no_of_gb: 1, ...props };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {}

  componentDidMount() {
    // uncomment below line to generate a image in the background
    // this.props.generateImage(this.state.product_id, this.state.setno);
    
  }

  amount = this.props.amount
  

  createOrder = (data, actions) => {
    if (this.state.pg_order_id) return this.state.pg_order_id;
    const payload = { 
      event_id: this.props.event_id,
      no_of_wishers: this.props.no_of_wishers,
      price: this.props.price,
      //amount: this.props.amount,
      amount: this.amount,
     };
    let uri = ENDPOINTS.user_events.create.uri;
    return fetch(uri, {
      method: ENDPOINTS.user_events.create.method,
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ pg_order_id: response.pg_order_id });
        return response.pg_order_id;
      });
  };

  onApprove = (data, actions) => {
    localStorage.setItem("isEventPaid", "true");
    if (this.props.extraWishersFlg) 
      localStorage.setItem("PayPalPaymentExtra", true)
    else
      localStorage.setItem("PayPalPayment", true); 
    let uri = ENDPOINTS.user_events.capture.uri;
    //let storage_unit = this.props.storage_unit;
    let no_of_wishers = this.props.no_of_wishers;
    let price = this.props.price;
    let extraWishers = this.props.extraWishers;
    return fetch(uri, {
      method: ENDPOINTS.user_events.capture.method,
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        paypal_order_id: data.orderID,
        //storage_unit: storage_unit,
        no_of_wishers: no_of_wishers,
        price: price,
        extraWishersFlg: this.props.extraWishersFlg,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        //localStorage.setItem("PayPalPayment", true); 
        //alert("Payment done successfully\nClick 'Event Link' to get the link to share");
        window.location.reload();
        return data.pg_order_id;
      });
  };

  onSuccess = (details, data) => {
    alert("payment done successfully");
  };

  onCancel = (data, actions) => {
    localStorage.removeItem("isEventPaid", "true");
    localStorage.removeItem("PayPalPaymentExtra", "true")
    localStorage.removeItem("PayPalPayment", "true")
    alert("Payment cancelled");
  };

  onError = (data, actions) => {
    localStorage.removeItem("isEventPaid", "true");
    localStorage.removeItem("PayPalPaymentExtra", "true")
    localStorage.removeItem("PayPalPayment", "true")
    alert("Something went wrong please try again later");
  };

  render() {
    const PaypalButton = window.paypal.Buttons.driver("react", {
      React,
      ReactDOM,
    });
    return (
      <PaypalButton
        {...this.props}
        createOrder={this.createOrder}
        onApprove={this.onApprove}
        // onApprove={e => this.onApprove(e)}
        onSuccess={this.onSuccess}
        onError={this.onError}
        onCancel={this.onCancel}
        // style={style}
      />
    );
  }
}

export default EventPayment;
